import { useState, useCallback } from 'react';

// Services

import OptionsService from '../services/options.service';

export default function GetPhoneAreaCodesByState() {
    const [getPhoneAreaCodesIsLoading, setGetPhoneAreaCodesIsLoading] = useState(false);
    const [getPhoneAreaCodesError, setGetPhoneAreaCodesError] = useState(null);
    const [phoneAreaCodes, setPhoneAreaCodes] = useState([]);

    // Get the Phone Area Codes by State

    const handleGetPhoneAreaCodesByState = useCallback(async (state) => {
        setGetPhoneAreaCodesIsLoading(true);
        setGetPhoneAreaCodesError(null);

        try {
            const phoneAreaCodesRequest = await OptionsService.getPhoneAreaCodesByState(state);

            setGetPhoneAreaCodesIsLoading(false);
            setPhoneAreaCodes(phoneAreaCodesRequest?.data?.data);

        } catch(error) {    

            setGetPhoneAreaCodesIsLoading(false);
            setGetPhoneAreaCodesError(error.response?.data?.message || error.message);

        }
    }, []);

    return {
        getPhoneAreaCodesIsLoading,
        getPhoneAreaCodesError,
        phoneAreaCodes,
        handleGetPhoneAreaCodesByState,
    }
}
